import { FC } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../atomic/button';
import { CardApprovalRequest } from '../../../../../queries/pxtraCard';
import { isDecidable } from '../utils';

type Props = {
  request: CardApprovalRequest;
  canApprove: boolean;
  onApprove: (request: CardApprovalRequest) => void;
  onReject: (request: CardApprovalRequest) => void;
};

export const ApprovalActionsCell: FC<Props> = ({ request, canApprove, onApprove, onReject }) => {
  const { t } = useTranslation();

  if (!isDecidable(request)) return null;

  if (request.status === 'failed') {
    return (
      <Button
        variant="tertiary"
        size="xsmall"
        disabled={!canApprove}
        onClick={() => onApprove(request)}
      >
        {t('pxtraCard:retry')}
      </Button>
    );
  }

  return (
    <Box className="flex gap-1">
      <Button size="xsmall" disabled={!canApprove} onClick={() => onApprove(request)}>
        {t('pxtraCard:approve')}
      </Button>
      <Button variant="tertiary" color="error" size="xsmall" onClick={() => onReject(request)}>
        {t('pxtraCard:reject')}
      </Button>
    </Box>
  );
};
